// Product slider initialization
window.addEventListener('DOMContentLoaded', function () {
    $('.js-product-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        prevArrow: $('.product-slider--prev'),
        nextArrow: $('.product-slider--next'),
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 3 }
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 480,
                settings: { slidesToShow: 1.5 }
            }
        ]
    });
});

// Move popup modals to body
document.addEventListener('DOMContentLoaded', function () {
    const popups = document.querySelectorAll('.popup-modal');

    popups.forEach(popup => {
        if (!document.body.contains(popup)) return;

        document.body.appendChild(popup);
    });
});

// Product carousel functionality
document.querySelectorAll('.product-list-item-thumbnail').forEach((carouselWrapper) => {
    const carouselImage = carouselWrapper.querySelector('.product-image-carousel img');
    const media = Array.from(carouselWrapper.querySelectorAll('.carousel-slide img'));
    const dots = carouselWrapper.querySelectorAll('.carousel-dots .dot');
    const prevButton = carouselWrapper.querySelector('.carousel-prev');
    const nextButton = carouselWrapper.querySelector('.carousel-next');
    let currentIndex = 0;

    const updateCarousel = () => {
        carouselImage.src = media[currentIndex].src;
        carouselImage.alt = media[currentIndex].alt;

        dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === currentIndex);
        });
    };

    updateCarousel();

    prevButton.addEventListener('click', () => {
        currentIndex = (currentIndex > 0) ? currentIndex - 1 : media.length - 1;
        updateCarousel();
    });

    nextButton.addEventListener('click', () => {
        currentIndex = (currentIndex < media.length - 1) ? currentIndex + 1 : 0;
        updateCarousel();
    });

    dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
            currentIndex = index;
            updateCarousel();
        });
    });
});

// Popup modal functionality
document.addEventListener('DOMContentLoaded', () => {
    const popupModals = document.querySelectorAll('.popup-modal');
    const headerMobile = document.querySelector('.main-header');

    document.querySelectorAll('.open-popup').forEach((button) => {
        button.addEventListener('click', () => {
            const popupId = button.getAttribute('data-popup');
            const targetPopup = document.querySelector(`#${popupId}`);

            if (targetPopup) {
                if (targetPopup.classList.contains('visible')) {

                    targetPopup.classList.remove('visible');
                    if (window.innerWidth < 990) {
                        headerMobile.style.display = 'block';
                    }

                    resetAccordions(targetPopup);
                } else {

                    popupModals.forEach((popup) => {
                        popup.classList.remove('visible');
                    });

                    targetPopup.classList.add('visible');
                    if (window.innerWidth < 990) {
                        headerMobile.style.display = 'none';
                    }

                    resetAccordions(targetPopup);
                }
            }
        });
    });

    document.querySelectorAll('.close-popup').forEach((closeButton) => {
        closeButton.addEventListener('click', () => {
            const popup = closeButton.closest('.popup-modal');
            popup.classList.remove('visible');

            if (window.innerWidth < 990) {
                headerMobile.style.display = 'block';
            }

            resetAccordions(popup);
        });
    });

    document.querySelectorAll('.accordion-item button').forEach((accordionButton) => {
        accordionButton.addEventListener('click', () => {
            const content = accordionButton.nextElementSibling;
            const isVisible = content.classList.contains('visible');

            const accordion = accordionButton.closest('.accordion');
            accordion.querySelectorAll('.accordion-content').forEach((item) => {
                item.classList.remove('visible');
            });
            accordion.querySelectorAll('button').forEach((button) => {
                button.classList.remove('active');
            });

            if (!isVisible) {
                content.classList.add('visible');
                accordionButton.classList.add('active');
            }
        });
    });

    function resetAccordions(popup) {
        const allAccordionContents = popup.querySelectorAll('.accordion-content');
        const allAccordionButtons = popup.querySelectorAll('.accordion-item button');

        allAccordionContents.forEach((content) => content.classList.remove('visible'));
        allAccordionButtons.forEach((button) => button.classList.remove('active'));

        const firstAccordion = popup.querySelector('.accordion-content.first_acc');
        if (firstAccordion) {
            firstAccordion.classList.add('visible');
            const firstAccordionButton = firstAccordion.previousElementSibling;
            if (firstAccordionButton) {
                firstAccordionButton.classList.add('active');
            }
        }
    }
});
